<template>
  <div>

    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/main.jpg')"
      />
      <div class="content-center">
        <div class="container">
          <h1 class="title">
            Seu Software Rodando Na Nuvem!!!
          </h1>
        </div>
      </div>
    </div>

    <a name="sobre" />
    <div class="section section-about-us pb-0">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">
              Quem Somos?
            </h2>
            <h5 class="description">
              A Leviatan é especializada em computação em nuvem e fornecemos a infraestrutura digital
              necessária para hospedar seu software em Kubernetes, garantindo a segurança do sistema
              enquanto nossa plataforma automatiza as rotinas que mantém o serviço funcionando.
            </h5>
          </div>
        </div>
        <div class="separator separator-primary" />
        <div class="section-story-overview">
          <div class="row">
            <div class="col-md-6">
              <div
                class="image-container image-left"
                style="background-image: url('img/computer.jpg')"
              >
                <!-- First image on the left side -->
                <p class="blockquote blockquote-primary">
                  "Simplificação da área de tecnologia, estabilidade e crescimento rápido.
                  Esses são alguns dos principais motivos que incentivam as empresas a
                  investir na computação em nuvem."
                  <br />
                  <br />
                  <small>-Revista EXAME</small>
                </p>
              </div>
              <!-- Second image on the left side of the article -->
              <div
                class="image-container"
                style="background-image: url('img/tablet.jpg')"
              />
            </div>
            <div class="col-md-5">
              <!-- First image on the right side, above the article -->
              <div
                class="image-container image-right"
                style="background-image: url('img/office.jpg')"
              />
              <h3 class="mt-4">
                Administre sua infraestrutura sem se preocupar em manter o software online
              </h3>
              <p>
                O termo <i>"nuvem"</i> foi criado para designar todo tipo de
                software que roda fora das dependências físicas das empresas e
                permite, dentre várias outras vantagens, enorme escalabilidade
                ao possibilitar o aluguel de servidores diretamente das maiores
                empresas de tecnologia — Amazon (AWS), Google (GCP), Microsoft
                (Azure) — num processo tão simples quanto o clicar de alguns botões.
              </p>
              <p>
                Para tirar mais vantagem desse novo modelo, o próprio processo
                de criação e entrega dos serviços digitais mudou para se assemelhar
                cada vez mais aos containers que transportam cargas pelos portos do
                mundo, onde cada unidade (container) é igual às demais, resultando
                na arquitetura de microserviços presente por toda a internet.
              </p>
              <p>
                Como novos paradigmas geram novos desafios, a complexidade da operação
                aumentou drasticamente e passa pela orquestração dos containers que
                compõe os serviços, pelo uso da criptografia para segurança das
                informações e pela observabilidade e monitoramento que garantem
                que a operação está funcionando como deveria.
              </p>
              <p>
                Essas são as responsabilidades que a Leviatan assume por você.
                <font class="text-warning" style="font-weight: bold;">Tomamos
                conta da sua nuvem enquanto você toma conta do seu negócio!</font>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a name="como-ajudamos-sua-empresa" />
    <div class="section section-team text-center pb-0">
      <div class="container">
        <h2 class="title">
          Como Ajudamos Sua Empresa
        </h2>
        <div class="team">
          <div class="row">
            <div class="col-md-4">
              <div class="team-player">
                <img
                  src="img/kubernetes.png"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title text-primary">
                  Orquestração
                </h4>
                <p class="description">
                  Usamos Kubernetes para automatizar a
                  criação, dimensionamento e gerenciamento
                  das aplicações, enfatizando sua automação e
                  aumentando a confiabilidade dos sistemas.
                </p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="team-player">
                <img
                  src="img/storage.png"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title text-primary">
                  Armazenamento
                </h4>
                <p class="description">
                  Garantimos a persistência das informações
                  atendendo qualquer requerimento do seu produto
                  por meio de banco de dados, sistema de
                  arquivos tradicional ou objetos em <i>buckets</i>.
                </p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="team-player">
                <img
                  src="img/shield.png"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title text-primary">
                  Segurança Da Informação
                </h4>
                <p class="description">
                  Desde a sua concepção, nossa plataforma
                  prioriza o isolamento entre todas as aplicações
                  para atender princípios de governança digital,
                  privacidade e conformidades legais (LGPD).
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a name="contato" />
    <div class="section section-contact-us text-center">
      <div class="container">
        <h2 class="title">
          Quer Saber Mais?
        </h2>
        <p class="description">
          Entre em contato conosco e um dos nossos representantes responderá em breve!
        </p>
        <div class="row">

          <div class="col-xs-12 col-sm-12 col-md-8 col-lg-6 text-center mx-auto">

            <form @submit.prevent="sendMail" autocomplete="on">

              <!-- https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete#Values -->

              <fg-input
                v-model="contactForm.name"
                addon-left-icon="now-ui-icons users_single-02"
                placeholder="Seu nome..."
                autocomplete="name"
                class="input-lg px-0"
                :class="{ 'has-danger': contactForm.errors.has('name') }"
                @keydown="contactForm.errors.clear('name')"
                :disabled="sending"
              />

              <fg-input
                v-model="contactForm.email"
                addon-left-icon="now-ui-icons ui-1_email-85"
                placeholder="Seu e-mail..."
                autocomplete="email"
                class="input-lg px-0"
                :class="{ 'has-danger': contactForm.errors.has('email') }"
                @keydown="contactForm.errors.clear('email')"
                :disabled="sending"
              />

              <fg-input
                v-model="contactForm.subject"
                addon-left-icon="now-ui-icons business_briefcase-24"
                placeholder="Assunto..."
                autocomplete="off"
                class="input-lg px-0"
                :class="{ 'has-danger': contactForm.errors.has('subject') }"
                @keydown="contactForm.errors.clear('subject')"
                :disabled="sending"
              />

              <div class="textarea-container">
                <textarea
                  v-model="contactForm.message"
                  placeholder="Digite sua mensagem..."
                  class="form-control"
                  @keydown="contactForm.errors.clear('message')"
                  :disabled="sending"
                />
                <div
                  v-if="contactForm.message.length"
                  class="text-right"
                  :class="{ 'text-danger': contactForm.message.length > 300 }"
                >
                  {{ contactForm.message.length }}<font style="font-weight: bold;" v-text="'/300'" />
                </div>
              </div>

              <alert
                v-if="alert.message && alert.type"
                class="text-left"
                :type=alert.type
              >
                <div v-if="alert.type === 'success'" class="alert-icon">
                  <i class="now-ui-icons ui-2_like" />
                </div>
                {{ alert.message }}
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="clearAlertMessage"
                >
                  <span aria-hidden="true">
                    <i class="now-ui-icons ui-1_simple-remove" />
                  </span>
                </button>
              </alert>

              <div
                class="send-button"
                :class="{ 'sending-or-failed-wrapper': sending || contactForm.errors.any() }"
              >
                <n-button
                  :type="sending || contactForm.errors.any() ? 'default' : 'primary'"
                  :class="{ 'sending-or-failed-button': sending || contactForm.errors.any() }"
                  round
                  block
                  size="lg"
                  @click="sendMail"
                >
                  Enviar Mensagem
                </n-button>
              </div>

            </form>

          </div>

        </div>
      </div>
    </div>

  </div>
</template>
<script>
import {
  Alert,
  Button,
  FormGroupInput
} from '@/components';
export default {
  name: 'Landing',
  bodyClass: 'landing-page',
  components: {
    Alert,
    [Button.name]: Button,                 // == n-button
    [FormGroupInput.name]: FormGroupInput  // == fg-input
  },
  data() {
    return {
      alert: {
        message: '',
        type: '',
      },
      contactForm: new AxiosForm(Object, {
        email: '',
        message: '',
        name: '',
        subject: '',
      }),
      sending: false,
    };
  },
  methods: {
    clearAlertMessage() {
      this.alert.message = '';
      this.alert.type = '';
      this.sending = false;
    },
    // Função de envio dos dados do formulário
    sendMail() {
      // Desabilita o formulário enquanto o POST é enviado
      this.sending = true;

      // Envia os dados
      this.contactForm
        .post('/contact-us')
        .then(() => {
          this.contactForm.reset(true);
          this.alert.message = 'Mensagem enviada com sucesso!';
          this.alert.type = 'success';
        })
        .catch(() => {
          this.alert.message = 'Houve um erro ao enviar o formulário...';
          this.alert.type = 'danger';
        });
    }
  },
};
</script>

<style>
.sending-or-failed-button {
  pointer-events: none;
}

.sending-or-failed-wrapper {
  cursor: not-allowed;
}
</style>
